// extracted by mini-css-extract-plugin
module.exports = {"content":"PrivacyPolicyPage_content__1jkna"};